var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dragging",
      staticClass: "floating-icon flex-center",
      style: { right: _vm.right + "px", bottom: _vm.bottom + "px" },
      on: {
        mousedown: _vm.startDrag,
        mouseout: function ($event) {
          _vm.onMouseout = true
        },
        mouseleave: function ($event) {
          _vm.onMouseout = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "icon flex-center",
          class: [_vm.onMouseout ? "text-show" : "text-hide"],
          on: { click: _vm.toggleVisibility },
        },
        [
          _c("img", {
            staticStyle: { width: "24px", height: "24px" },
            attrs: { src: require("@/static/draggable_icon.png"), alt: "" },
          }),
          _vm.onMouseout
            ? _c(
                "span",
                { staticClass: "font-14 color-fff font-light margin-left-5" },
                [_vm._v("提交工单")]
              )
            : _vm._e(),
        ]
      ),
      _vm.workVisible
        ? _c("workAdd", {
            attrs: { visible: _vm.workVisible },
            on: { close: _vm.closeWork },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }